import React from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import DefaultLayout from "../components/layout/DefaultLayout";
import LoadingMessage from "../components/LoadingMessage";
import ErrorMessage from "../components/ErrorMessage";
import { useEffect } from "react";
import { validateToken } from "../actions/users";
import ChangePassword from "../components/recoveryPassword/ChangePassword";
import { useNavigate } from "react-router-dom";

function RecoveryPasswordPage() {
  const { recovery_token } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.user.recovery.loading);
  const isValidToken = useSelector((state) => state.user.recovery.validToken);
  const redirectTo = useSelector((state) => state.user.redirectTo);

  useEffect(() => {
    if (redirectTo) {
      navigate(redirectTo);
    }
    dispatch(validateToken(recovery_token));
  }, [recovery_token, redirectTo]);

  if (isLoading) {
    return <LoadingMessage></LoadingMessage>;
  } else if (isValidToken) {
    const body = () => {
      return <ChangePassword recovery_token={recovery_token} />;
    };
    return (
      <div>
        <div>
          <DefaultLayout body={body()} />
        </div>
      </div>
    );
  } else {
    return <ErrorMessage message="Token invalido"></ErrorMessage>;
  }
}

export default RecoveryPasswordPage;
